// extracted by mini-css-extract-plugin
export var main__container = "Images-module--main__container--ef188";
export var main_img = "Images-module--main_img--13466";
export var more_images = "Images-module--more_images--2793e";
export var next_button = "Images-module--next_button--e4267";
export var prev_button = "Images-module--prev_button--64735";
export var preview_container = "Images-module--preview_container--99f9c";
export var preview_img = "Images-module--preview_img--525b7";
export var preview_overlay = "Images-module--preview_overlay--69664";
export var preview_video = "Images-module--preview_video--40399";
export var slide = "Images-module--slide--e7fed";
export var slide_container = "Images-module--slide_container--3a564";
export var slide_container_img = "Images-module--slide_container_img--0b287";
export var slider = "Images-module--slider--0170a";
export var video = "Images-module--video--ef8a8";
export var video_container = "Images-module--video_container--160de";
export var video_icon = "Images-module--video_icon--e0671";
export var video_icon_container = "Images-module--video_icon_container--29d6f";